module.exports.soic = {
    dimension: require("./dimensions/SOIC-SOP-Labeled.svg"),
    thumbnail: require("./thumbnails/SOIC-SOP.svg")
};

module.exports.cfp = {
    dimension: require("./dimensions/CFP-Labeled.svg"),
    thumbnail: require("./thumbnails/CFP.svg")
};

module.exports.sod = {
    dimension: require("./dimensions/SOD-Labeled.svg"),
    thumbnail: require("./thumbnails/SOD.svg")
};

module.exports.qfp = {
    dimension: require("./dimensions/QFP-Labeled.svg"),
    thumbnail: require("./thumbnails/QFP.svg")
};

module.exports.cqfp = {
    dimension: require("./dimensions/CQFP-Labeled.svg"),
    thumbnail: require("./thumbnails/CQFP.svg")
};

module.exports.qfn = {
    dimension: require("./dimensions/QFN-Labeled.svg"),
    thumbnail: require("./thumbnails/QFN.svg")
};

module.exports.sot23 = {
    dimension: require("./dimensions/SOT23-Labeled.svg"),
    thumbnail: require("./thumbnails/SOT23.svg")
};

module.exports.sotfl = {
    dimension: require("./dimensions/SOTFL-Labeled.svg"),
    thumbnail: require("./thumbnails/SOTFL.svg")
};

module.exports.sot223 = {
    dimension: require("./dimensions/SOT223-Labeled.svg"),
    thumbnail: require("./thumbnails/SOT223.svg")
};

module.exports.sot143 = {
    dimension: require("./dimensions/SOT143-Labeled.svg"),
    thumbnail: require("./thumbnails/SOT143.svg")
};

module.exports.dpak = {
    dimension: require("./dimensions/TO-DPAK-Labeled.svg"),
    thumbnail: require("./thumbnails/TO-DPAK.svg")
};

module.exports.chip = {
    dimension: require("./dimensions/Chip-Labeled.svg"),
    thumbnail: require("./thumbnails/Chip.svg")
};

module.exports.moldedBody = {
    dimension: require("./dimensions/Molded-Body-Labeled.svg"),
    thumbnail: require("./thumbnails/Molded-Body.svg")
};

module.exports.sodfl = {
    dimension: require("./dimensions/SODFL-Labeled.svg"),
    thumbnail: require("./thumbnails/SODFL.svg")
};

module.exports.dfn2 = {
    dimension: require("./dimensions/DFN-2-Labeled.svg"),
    thumbnail: require("./thumbnails/DFN-2.svg")
};

module.exports.dfn3 = {
    dimension: require("./dimensions/DFN-3-Labeled.svg"),
    thumbnail: require("./thumbnails/DFN-3.svg")
};

module.exports.dfn4 = {
    dimension: require("./dimensions/DFN-4-Labeled.svg"),
    thumbnail: require("./thumbnails/DFN-4.svg")
};

module.exports.ecap = {
    dimension: require("./dimensions/E-Cap-Labeled.svg"),
    thumbnail: require("./thumbnails/E-Cap.svg")
};

module.exports.crystal = {
    dimension: require("./dimensions/Crystal-Labeled.svg"),
    thumbnail: require("./thumbnails/Crystal.svg")
};

module.exports.bga = {
    dimension: require("./dimensions/BGA-Labeled.svg"),
    thumbnail: require("./thumbnails/BGA.svg")
};

module.exports.melf = {
    dimension: require("./dimensions/MELF-Labeled.svg"),
    thumbnail: require("./thumbnails/MELF.svg")
};

module.exports.chipArray2FlatConcave = {
    dimension: require("./dimensions/ChipArray-2side-FlatConcave-Labeled.svg"),
    thumbnail: require("./thumbnails/ChipArray-2side-FlatConcave.svg")
};

module.exports.chipArray4FlatConcave = {
    dimension: require("./dimensions/ChipArray-4side-FlatConcave-Labeled.svg"),
    thumbnail: require("./thumbnails/ChipArray-4side-FlatConcave.svg")
};

module.exports.chipArray2Convex = {
    dimension: require("./dimensions/ChipArray-2side-Convex-Labeled.svg"),
    thumbnail: require("./thumbnails/ChipArray-2side-Convex.svg")
};

module.exports.plcc = {
    dimension: require("./dimensions/PLCC-Labeled.svg"),
    thumbnail: require("./thumbnails/PLCC.svg")
};

module.exports.oscCornerConcave = {
    dimension: require("./dimensions/Oscillator-Corner-Concave-Labeled.svg"),
    thumbnail: require("./thumbnails/Oscillator-Corner-Concave.svg")
};

module.exports.oscLBend = {
    dimension: require("./dimensions/Oscillator-LBend-Labeled.svg"),
    thumbnail: require("./thumbnails/Oscillator-LBend.svg")
};

module.exports.oscJLead = {
    dimension: require("./dimensions/Oscillator-JLead-Labeled.svg"),
    thumbnail: require("./thumbnails/Oscillator-JLead.svg")
};

module.exports.soj = {
    dimension: require("./dimensions/SOJ-Labeled.svg"),
    thumbnail: require("./thumbnails/SOJ.svg")
};

module.exports.axial = {
    dimension: require("./dimensions/Axial-Labeled.svg"),
    thumbnail: require("./thumbnails/Axial.svg")
};

module.exports.dip = {
    dimension: require("./dimensions/DIP-Labeled.svg"),
    thumbnail: require("./thumbnails/DIP.svg")
};

module.exports.headerStraight = {
    dimension: require("./dimensions/Header-Male-Straight-Labeled.svg"),
    thumbnail: require("./thumbnails/Header-Male-Straight.svg"),
    pinSequence: {
        "ZZBT": require("./icons/ZZBT.svg"),
        "LRCW": require("./icons/LRCW.svg"),
        "LRCCW": require("./icons/LRCCW.svg")
    }
};

module.exports.headerRightAngle = {
    dimension: require("./dimensions/Header-Male-Right-Angle-Labeled.svg"),
    thumbnail: require("./thumbnails/Header-Male-Right-Angle.svg"),
    pinSequence: {
        "ZZBT": require("./icons/ZZBT.svg"),
        "LRCW": require("./icons/LRCW.svg"),
        "LRCCW": require("./icons/LRCCW.svg")
    }
};

module.exports.headerStraightSocket = {
    dimension: require("./dimensions/Header-Female-Straight-Labeled.svg"),
    thumbnail: require("./thumbnails/Header-Female-Straight.svg"),
    pinSequence: {
        "ZZBT": require("./icons/ZZBT.svg"),
        "LRCW": require("./icons/LRCW.svg"),
        "LRCCW": require("./icons/LRCCW.svg")
    }
};

module.exports.headerRightAngleSocket = {
    dimension: require("./dimensions/Header-Female-Right-Angle-Labeled.svg"),
    thumbnail: require("./thumbnails/Header-Female-Right-Angle.svg"),
    pinSequence: {
        "ZZBT": require("./icons/ZZBT.svg"),
        "LRCW": require("./icons/LRCW.svg"),
        "LRCCW": require("./icons/LRCCW.svg")
    }
};

module.exports.son = {
    dimension: require("./dimensions/SON-Labeled.svg"),
    thumbnail: require("./thumbnails/SON.svg")
};

module.exports.radialRound = {
    dimension: require("./dimensions/Radial-Round-Labeled.svg"),
    thumbnail: require("./thumbnails/Radial-Round.svg")
};

module.exports.radialLedRound = {
    dimension: require("./dimensions/Radial-Led-Round-Labeled.svg"),
    thumbnail: require("./thumbnails/Radial-Led-Round.svg")
};

module.exports.crystalHC49 = {
    dimension: require("./dimensions/Crystal-HC49-Labeled.svg"),
    thumbnail: require("./thumbnails/Crystal-HC49.svg")
};

module.exports.femaleStandoffSpacerData = {
    dimension: require("./dimensions/Standoff-Female-Labeled.svg"),
    thumbnail: require("./thumbnails/Standoff-Female.svg")
};

module.exports.maleFemaleStandoffSpacerData = {
    dimension: require("./dimensions/Standoff-Male-Female-Labeled.svg"),
    thumbnail: require("./thumbnails/Standoff-Male-Female.svg")
};

module.exports.SnapLockData = {
    dimension: require("./dimensions/Snap-Lock-Labeled.svg"),
    thumbnail: require("./thumbnails/Snap-Lock.svg")
};

module.exports.ChipLed = {
    dimension: require("./dimensions/Chip-Led-Labeled.svg"),
    thumbnail: require("./thumbnails/Chip-Led.svg")
};

module.exports.solderPastePattern = global.FULLDEPLOYMENTPATH + require("./dimensions/Solder-Paste-Pattern.svg");
module.exports.customFootprintChip = global.FULLDEPLOYMENTPATH + require("./dimensions/Chip-Custom-Footprint.svg");
module.exports.customFootprintMolded = global.FULLDEPLOYMENTPATH + require("./dimensions/Molded-Custom-Footprint.svg");
module.exports.customFootprintSod = global.FULLDEPLOYMENTPATH + require("./dimensions/SOD-Custom-Footprint.svg");
module.exports.customFootprintSoic = global.FULLDEPLOYMENTPATH + require("./dimensions/SOIC-Custom-Footprint.svg");
module.exports.customFootprintBga = global.FULLDEPLOYMENTPATH + require("./dimensions/Bga-Custom-Footprint.svg");
module.exports.customFootprintQuadPackage = global.FULLDEPLOYMENTPATH + require("./dimensions/Quad-Custom-Footprint.svg");
module.exports.customFootprintPlcc = global.FULLDEPLOYMENTPATH + require("./dimensions/Plcc-Custom-Footprint.svg");
module.exports.customFootprintDfn2 = global.FULLDEPLOYMENTPATH + require("./dimensions/Dfn2-Custom-Footprint.svg"); 
module.exports.customFootprintDfn3 = global.FULLDEPLOYMENTPATH + require("./dimensions/Dfn3-Custom-Footprint.svg");
module.exports.customFootprintDfn4 = global.FULLDEPLOYMENTPATH + require("./dimensions/Dfn4-Custom-Footprint.svg");
module.exports.customFootprintSon = global.FULLDEPLOYMENTPATH + require("./dimensions/Son-Custom-Footprint.svg");
module.exports.customFootprintMelf = global.FULLDEPLOYMENTPATH + require("./dimensions/SOD-Custom-Footprint.svg"); // custom footprint image is same as SOD
module.exports.customFootprintEcap = global.FULLDEPLOYMENTPATH + require("./dimensions/SOD-Custom-Footprint.svg"); // custom footprint image is same as SOD
module.exports.customFootprintChipLed = global.FULLDEPLOYMENTPATH + require("./dimensions/SOD-Custom-Footprint.svg"); // custom footprint image is same as SOD
module.exports.customFootprintSodfl = global.FULLDEPLOYMENTPATH + require("./dimensions/Molded-Custom-Footprint.svg"); // custom footprint image is same as molded
module.exports.customFootprintOscJ = global.FULLDEPLOYMENTPATH + require("./dimensions/OscJL-Custom-Footprint.svg"); 
module.exports.customFootprintOscL = global.FULLDEPLOYMENTPATH + require("./dimensions/OscJL-Custom-Footprint.svg");
module.exports.customFootprintSoj = global.FULLDEPLOYMENTPATH + require("./dimensions/SOIC-Custom-Footprint.svg");// custom footprint is same as SOIC
module.exports.customFootprintToDpak = global.FULLDEPLOYMENTPATH + require("./dimensions/ToDpak-Custom-Footprint.svg");
module.exports.customFootprintSot23 = global.FULLDEPLOYMENTPATH + require("./dimensions/Sot23-Custom-Footprint.svg");
module.exports.customFootprintSotfl = global.FULLDEPLOYMENTPATH + require("./dimensions/Sot23-Custom-Footprint.svg"); // custom footprint is same as sot23
module.exports.customFootprintSot223 = global.FULLDEPLOYMENTPATH + require("./dimensions/Sot223-Custom-Footprint.svg");
module.exports.customFootprintSot143 = global.FULLDEPLOYMENTPATH + require("./dimensions/Sot143-Custom-Footprint.svg");
module.exports.customFootprintOscConcave = global.FULLDEPLOYMENTPATH + require("./dimensions/OscConcave-Custom-Footprint.svg");
module.exports.customFootprintChipArray2SideConvex = global.FULLDEPLOYMENTPATH + require("./dimensions/ChipArray2SideConvex-Custom-Footprint.svg");
module.exports.customFootprintChipArray2SideFlat = global.FULLDEPLOYMENTPATH + require("./dimensions/ChipArray2SideFlat-Custom-Footprint.svg");
module.exports.customFootprintChipArray4SideFlat = global.FULLDEPLOYMENTPATH + require("./dimensions/ChipArray4SideFlat-Custom-Footprint.svg");
module.exports.customFootprintCrystal = global.FULLDEPLOYMENTPATH + require("./dimensions/Crystal-Custom-Footprint.svg");